// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"3364c777","161":"97bd3af6","481":"9cb83243","961":"d4317e98"}[chunkId] + ".chunk.css";
};